import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';

import { FsDolpShare } from '@lib/api/entities';
import { SnCommonModule } from '@lib/common';
import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';
import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';

import { Dolp } from '../../types/dolp';
import { DolpShareComponent } from '../dolp-share/dolp-share.component';

@Component({
  selector: 'sn-dolp-share-crossorg-table',
  templateUrl: './dolp-share-crossorg-table.component.html',
  styleUrls: ['./dolp-share-crossorg-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatRippleModule,
    MatTableModule,
    SnButtonModule,
    SnCommonModule,
    TranslationModule,
  ],
})
export class DolpShareCrossorgTableComponent
  extends SnTableBaseComponent<FsDolpShare>
  implements OnDestroy, OnInit
{
  @Input() public originalAccess: Dolp;

  public share: string[] = [];

  private readonly _destroy$ = new Subject();

  constructor(private readonly _dialogRef: MatDialogRef<DolpShareComponent>) {
    super();
  }

  public ngOnInit(): void {
    this.items = cloneDeep(this.items);
    this._handleDolpLoaded();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackBy(index: number, item: FsDolpShare): any {
    return item.id;
  }

  public save(): void {
    const data = {
      shares: this.share,
    };

    this._dialogRef.close(data);
  }

  public controlActions(e: MatCheckboxChange, id: any, action: string): void {
    const changedBoxID = this.items.findIndex((u) => u.id === id);
    if (action === 'share') {
      this.items[changedBoxID].share = e.checked;
      if (this.items[changedBoxID].share) {
        this.share.push(id);
      } else {
        const index = this.share.indexOf(id);
        if (index > -1) {
          this.share.splice(index, 1);
        }
      }
    }
  }

  private _handleDolpLoaded(): void {
    const data = this.originalAccess;

    this.share = cloneDeep(data?.shares.map((u) => u.id)) || [];
    this.items.forEach((crossOrg) => {
      if (this.share && this.share.filter((share) => share === crossOrg.id).length > 0) {
        crossOrg.share = true;
      }
    });
  }
}
